<div *ngIf="loading" class="center">
  <mat-spinner class="mat-spinner-color"></mat-spinner>
</div>

<div *ngIf="!loading">
  <mat-sidenav-container>
    <mat-sidenav #sidenav class="sideBar">
      <a class="back-arrow" (click)="sidenav.toggle()" id="sidebarBtn">
        <i class="material-icons" style="cursor: pointer; float: left; margin: 5px; font-size: 20px;">
          arrow_back_ios
        </i>
        <span style="font-size: large; vertical-align: -webkit-baseline-middle;">Back</span>
      </a>
      <br>
      <app-sidebar></app-sidebar>
    </mat-sidenav>

    <mat-sidenav-content style="background-color: white;">
      <div id="about"></div>
      <mat-sidenav-container hasBackdrop="false">
        <mat-sidenav #left position="end" class="info-container">
          <app-project-details-template></app-project-details-template>
        </mat-sidenav>
        <mat-sidenav-content>
          <header>
            <app-header></app-header>
            <a (click)="sidenav.toggle()" id="sideBarToggle" style="opacity: 0;"></a>
          </header>
          <!-- <div class="topSpace"></div> -->
          <!-- <router-outlet name="modal"></router-outlet> -->
          <app-info-wrapper></app-info-wrapper>
          <button mat-button (click)="left.toggle()" id="rightSideBar"
            style="width: 0; height: 0; opacity: 0;">left</button>
          <app-footer></app-footer>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
